import "./App.css";
import { Route, Router, Routes } from "react-router-dom";
import Navigation from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/home";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Packages from "./pages/packages";
import Gallery from "./pages/gallrey";
import Contact from "./pages/contact";
import About from "./pages/about";
import Booking from "./pages/booking";
import BevisBawa from "./pages/bevis_bawa";
import Register from "./pages/register";
import Login from "./pages/login";
import Shop from "./pages/shop";
import { CartProvider, useCart } from "./CartContext.jsx";
import CartPage from "./pages/cartPage.jsx";
import Checkout from "./pages/checkout.jsx";
import CheckoutPage from "./pages/checkout.jsx";
import { useEffect } from "react";

function App() {
  const location = useLocation();
  const hideNavAndFooter = location.pathname === "/login" || location.pathname === "/register";


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return (
    <CartProvider>
      {!hideNavAndFooter && <Navigation />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/about" element={<About />} />
        <Route path="/bevis_bawa" element={<BevisBawa />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />

      </Routes>
      {!hideNavAndFooter && <Footer />}
    </CartProvider>
  );
}

export default App;
